export default function Toast({ msg }) {
  return <div className={"toast" + (msg ? " show" : "")}>{msg}</div>;
}
